import { Controller } from "@hotwired/stimulus"
import { fetchJson } from "../lib/fetch_json"

export default class extends Controller {
  static targets = ["panel", "input", "status"]
  static values  = { updateUrl: String }

  toggle() {
    this.panelTarget.classList.toggle("hidden")
    if (!this.panelTarget.classList.contains("hidden")) {
      this.inputTarget.focus()
      this.inputTarget.select()
    }
  }

  close() {
    this.panelTarget.classList.add("hidden")
  }

  save() {
    const threshold = this.inputTarget.value.trim()
    fetchJson(this.updateUrlValue, {
      method: "PATCH",
      body: { favorite: { alert_threshold: threshold === "" ? null : threshold } }
    })
      .then(() => {
        this.close()
        const icon = this.element.querySelector("svg")
        if (icon) icon.setAttribute("stroke", threshold === "" ? "#444" : "#ccff00")
      })
      .catch(() => {
        if (this.hasStatusTarget) {
          this.statusTarget.textContent = "Erreur lors de la sauvegarde"
          this.statusTarget.classList.remove("hidden")
        }
      })
  }

  saveOnEnter(event) {
    if (event.key === "Enter") { event.preventDefault(); this.save() }
    if (event.key === "Escape") this.close()
  }

  disable() {
    this.inputTarget.value = ""
    this.save()
  }
}
